import { BulkUpdateReturnWorkflowsDto } from "../generated/schema.ts";
import { useApiMutation } from "./use-api-mutation";
import { invalidateAllShopEmailTemplatesKey } from "./use-get-all-shop-email-templates.ts";
import { invalidateAllReturnWorkflowsKey } from "./use-get-all-return-workflows.ts";

export default function useBulkUpdateReturnWorkflows(shopId: string) {
	return useApiMutation("patch", "/shops/{shopId}/return-workflows/bulk", {
		notify: false,
		meta: {
			success: {
				title: "workflows.editor.update.success.title",
				message: "workflows.editor.update.success.message",
			},
			error: {
				title: "workflows.editor.update.error.title",
				message: "workflows.editor.update.error.message",
			},
			invalidatesQuery: [
				invalidateAllReturnWorkflowsKey(shopId),
				invalidateAllShopEmailTemplatesKey(shopId),
			],
		},
		mapVariables: ({ requestBody }: { requestBody: BulkUpdateReturnWorkflowsDto }) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
